import { CustomBox } from "components";
import { SubscriptionRenewalRateIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends, getUserRate } from "../../helpers";

export function SubscriptionRenewalRate({ data, isLoading, totalUsers }: any) {
  const { today, thisWeek, thisMonth, thisYear, total } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      loading={isLoading}
      color="#FF8817"
      title="Subscription Renewal Rate"
      userCount={getUserRate({ value: total, total: totalUsers?.total }) + "%"}
      boxData={{
        label: "Renewal Rate",
        description:
          "The percentage of users who renew their subscription after the initial trial period.",
        todayCount:
          getUserRate({ value: today, total: totalUsers?.today }) + "%",
        weekCount:
          getUserRate({ value: thisWeek, total: totalUsers?.thisWeek }) + "%",
        monthCount:
          getUserRate({ value: thisMonth, total: totalUsers?.thisMonth }) + "%",
        yearCount:
          getUserRate({ value: thisYear, total: totalUsers?.thisYear }) + "%",
        icon: SubscriptionRenewalRateIcon,
      }}
      percentages={growthTrends}
    />
  );
}
